module.exports = __webpack_public_path__ + "flyer_background_manly_confetti_104-c8b3cffa9960f06de1b6443552e31823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_manly_confetti_104.jpg
// module id = 1660
// module chunks = 1